var renewModal = null;
function setRenewModal(modal) {
    renewModal = modal;
}
// function clearRenewModal() {
// 	renewModal = null;
// }
var openRenewModal = function (args) {
    if (args === void 0) { args = {}; }
    return renewModal !== null ? renewModal.open(args) : Promise.reject();
};
export { setRenewModal, /*clearRenewModal,*/ openRenewModal };
//# sourceMappingURL=renewModal.js.map